<template>
  <div>
    <section class="main-content">

      <div class="inner-banner">
            <div class="container">
                <div class="articles-box">
                    <figure class="pic articles-pic fitimg mb-0">
                        <img class="img-fluid" :src="'https://admin.weddingsung.com/upload/song/'+ this.getCategory.image_origin" />
                    </figure>
                    <div class="text">
                        <h3 class="title text-primary">{{this.getCategory.title}}</h3>
                        <article class="article-editor" v-html="this.getCategory.longcontext"></article>
                    </div>
                </div>
            </div>
        </div>

        <div class="main-block">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="bck-index bck-articles">
                            <h3 class="title"><span>精選婚禮主題</span></h3>
                            <div class="row">
                              
                              <div class="col-md-3" v-for="(row, index) in songdata">
                                  <div class="articles-items">
                                    <div class="articles-box topiclist-box">
                                      <figure class="pic articles-pic">
                                          <img class="img-fluid" :src="'https://admin.weddingsung.com/upload/song/'+row.image_path" />
                                      </figure>
                                        <blockquote class="blockquote article-blockquote">
                                          <h5 class="title mb-0 text-primary">{{row.title}}</h5>
                                          <article class="article-editor">
                                            <p class="txt" v-html="row.context"></p>
                                          </article>
                                          <ol class="topictop-list">
                                            <li>
                                                <span>{{row.link_title}}</span>
                                                <span>{{row.author}}</span>
                                            </li>
                                            <li>
                                                <span>{{row.link2_title}}</span>
                                                <span>{{row.author}}</span>
                                            </li>
                                            <li>
                                                <span>{{row.link3_title}}</span>
                                                <span>{{row.author}}</span>
                                            </li>
                                          </ol>
                                          <a class="btn btn-primary btn-block btn-sm" :href="'/topicview/'+row.id">MORE</a>
                                        </blockquote>
                                      </div>
                                  </div>
                              </div>
                            </div>

                        </div>

                    </div>

                </div>
            </div>
        </div>
        </section>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import Qs from 'qs'
export default {
  name: 'topic',
  data () {
    return {
      uri: this.$store.getters.getUri,
      categoryId: 6,
      category: {},
      songdata: Object,
      songLatest: Object
    }
  },
  computed: {
    ...mapGetters({
      lang: 'getSongTagLang'
    }),
    getCategory () {
      return this.$store.getters.getSongCategory[6 - 1]
    }
  },
  mounted: function () {
    this.searching()
  },
  methods: {
    ...mapActions([
      'UPDATEUSER'
    ]),
    searching () {
      let self = this
      // 取得分類中的歌曲
      if (this.categoryId !== '') {
        let uploadData = Qs.stringify({
          categoryId: this.categoryId
        })
        this.$http.post(this.uri + 'Song/get_songs_by_category', uploadData).then(function (res) {
          let data = res.data
          if (data.status === 200) {
            self.songdata = data.songs
            self.songLatest = data.songsLatest
          } else {
            console.log('下載歌曲失敗')
          }
        }).catch(function (error) {
          console.log(error)
        })
      } else {
        return false
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// Topic.vue?4f828b22